import { X, FileText, Image } from 'lucide-react'
import type { ChatAttachment } from '@/types/chat'

interface ChatAttachmentChipProps {
  attachment: ChatAttachment
  onRemove?: () => void
}

export function ChatAttachmentChip({ attachment, onRemove }: Readonly<ChatAttachmentChipProps>) {
  const isImage = attachment.contentType.startsWith('image/')
  const Icon = isImage ? Image : FileText

  return (
    <span
      className="flex min-h-[40px] items-center gap-1.5 rounded-full border bg-muted px-3 py-1 text-sm"
      data-testid="chat-attachment-chip"
    >
      <Icon className="h-4 w-4 shrink-0 text-muted-foreground" />
      <span className="max-w-[180px] truncate">{attachment.fileName}</span>
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          className="text-muted-foreground hover:text-foreground"
          aria-label={`Remove ${attachment.fileName}`}
        >
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </span>
  )
}
